import {Carousel} from "@mantine/carousel";
import {Box, Flex, Text} from "@mantine/core";
import {useRef} from "@wordpress/element";
import Autoplay from "embla-carousel-autoplay";

const _Category5 = ({component}) => {
    const autoplay = useRef(Autoplay({ delay: 4000 }));

    return (
        <Box
            bg={component?.customize_styles?.general_decoration?.background_color}
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            style={{
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
                borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
            }}
        >
            <Text
                fz="18px"
                c={component?.customize_styles?.text_decoration?.color}
                mx={component?.customize_styles?.text_decoration?.margin_x}
                my={component?.customize_styles?.text_decoration?.margin_y}
                px={component?.customize_styles?.text_decoration?.padding_x}
                py={component?.customize_styles?.text_decoration?.padding_y}
                bg={component?.customize_styles?.text_decoration?.background_color}
                lh='1'
                fw={700}
            >
                {component?.customize_properties?.label}
            </Text>
            <Carousel
                loop
                plugins={[autoplay.current]}
                onMouseEnter={autoplay.current.stop}
                onMouseLeave={autoplay.current.reset}
                slideSize={75}
                align="start"
                withControls={false}

            >
                {
                    component?.items?.map((item, index) => (
                        <Carousel.Slide key={item.id}>
                            <Flex
                                align="center"
                                justify="center"
                                direction="column"
                                bg={component?.customize_styles?.box_decoration?.background_color}
                                mx={component?.customize_styles?.box_decoration?.margin_x}
                                my={component?.customize_styles?.box_decoration?.margin_y}
                                px={component?.customize_styles?.box_decoration?.padding_x}
                                py={component?.customize_styles?.box_decoration?.padding_y}
                                style={{
                                    borderRadius: `${component?.customize_styles?.box_decoration?.border_radius}px`,
                                    border: `${component?.customize_styles?.box_decoration?.border_width}px solid ${component?.customize_styles?.box_decoration?.border_color}`,
                                    boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px -${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,

                                }}
                            >
                                <Text
                                    lineClamp={1}
                                    translate="yes"
                                    fz={component?.customize_styles?.name_text_decoration?.font_size}
                                    fw={component?.customize_styles?.name_text_decoration?.font_weight}
                                    fs={component?.customize_styles?.name_text_decoration?.font_style}
                                    mt={3}
                                    c={component?.customize_styles?.name_text_decoration?.color}
                                >
                                    {item.name}
                                </Text>
                            </Flex>
                        </Carousel.Slide>
                    ))
                }

            </Carousel>
        </Box>
    )
}
export default _Category5;